import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "../components/Layout";
import ProtectedRoute from "../components/ProtectedRoute";
import Dashboard from "../pages/Dashboard";
import Servers from "../pages/Servers";
import Packages from "../pages/Packages";
import Logs from "../pages/Logs";
import SignIn from "../pages/SignIn";
import CAGlobalSignIn from "../pages/SsoSignIn";
import InvalidLogin from "../pages/InvalidLogin";
import Settings from "../pages/Settings";
import UserManagement from "../pages/UserManagement";
import GroupConfiguration from "../pages/GroupConfiguration";

export default function AppRoutes() {
  return (
    <Routes>
      {/* Standard login */}
      <Route path="/signin" element={<SignIn />} />

      {/* CAGlobal SSO — public, no auth required */}
      <Route path="/caglobal"         element={<CAGlobalSignIn />} />
      <Route path="/caglobal/invalid" element={<InvalidLogin />} />

      {/* All authenticated pages share the Layout shell */}
      <Route element={<ProtectedRoute />}>
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="servers" element={<Servers />} />

          {/* Packages — needs updates permission (admins bypass) */}
          <Route element={<ProtectedRoute requiredPermission="updates" />}>
            <Route path="packages" element={<Packages />} />
          </Route>

          {/* Logs — needs logs permission (admins bypass) */}
          <Route element={<ProtectedRoute requiredPermission="logs" />}>
            <Route path="logs" element={<Logs />} />
          </Route>

          {/* Settings — admin only */}
          <Route element={<ProtectedRoute requiredRole="admin" />}>
            <Route path="settings" element={<Settings />} />
            <Route path="users" element={<UserManagement />} />
            <Route path="groups" element={<GroupConfiguration />} />
          </Route>

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}
